import { Injectable } from '@angular/core';

import { NativeAppService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class CCBEventService {
    static readonly EnableOsPrimer = 'enableOSPrimer';
    static readonly EnableOsPrimerParam = {
        displayOSPrimer: 'Yes',
        id: 'promohome',
    };
    constructor(private nativeAppService: NativeAppService) {}

    sentCCBEventToMobileApp() {
        if (
            this.nativeAppService.isNativeWrapper &&
            (this.nativeAppService.product == 'casino' ||
                this.nativeAppService.product == 'CASINO' ||
                this.nativeAppService.product == 'SPORTSBOOK' ||
                this.nativeAppService.product == 'sportsbook')
        )
            this.nativeAppService.sendToNative({
                eventName: CCBEventService.EnableOsPrimer,
                parameters: CCBEventService.EnableOsPrimerParam,
            });
    }
}
